import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import CircularProgressbar from 'react-circular-progressbar'
import startCase from 'lodash/startCase'
import ProgressBar from './ProgressBar'

const styles = (theme) => ({
  root: {
    border: `1px solid ${theme.palette.borders.cloudier}`,
    borderTop: '3px solid #824160',
    padding: 20,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 20,
    },
  },
  header: {
    color: '#333',
    textTransform: 'none',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.4em',
      fontWeight: 700,
    },
  },
  progressWrapper: {
    margin: 'auto',
    marginBottom: 20,
    width: 150,
  },
  progressCircle: {
    '&:hover': {
      transform: 'scale(1.15)',
    },
  },
  stats: {},
  pros: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.4em',
    },
  },
  cons: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.4em',
    },
  },
  ul: {
    fontSize: '0.9em',
  },
  button: {
    color: '#fff',
    borderRadius: 0,
    backgroundColor: theme.palette.button.callToAction,
    '&:hover': {
      opacity: 0.8,
      backgroundColor: theme.palette.button.callToAction,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },
})

const Summary = ({
  classes,
  theme,
  header,
  pros,
  cons,
  statistics,
  value,
  to,
}) => {
  let color

  if (value < 60) color = theme.palette.error.main
  else if (value >= 60 && value < 80) color = theme.palette.warning
  else if (value >= 80) color = '#2cad35'

  return (
    <div className={classes.root}>
      <Typography align="center" variant="headline" className={classes.header}>
        {header}
      </Typography>
      <Divider
        style={{ margin: '20px 0', color: theme.palette.borders.cloudier }}
      />
      <Grid spacing={24} container>
        <Grid xs={12} sm={6} item>
          <div className={classes.progressWrapper}>
            <CircularProgressbar
              percentage={value}
              text={`${value}%`}
              className={classes.progressCircle}
              styles={{
                path: {
                  stroke: color,
                },
                text: {
                  fontSize: '1em',
                  fill: color,
                },
              }}
              initialAnimation
            />
          </div>
          <div className={classes.stats}>
            {Object.keys(statistics).map((key) => (
              <ProgressBar
                key={key}
                label={startCase(key)}
                value={statistics[key]}
              />
            ))}
          </div>
        </Grid>
        <Grid xs={12} sm={6} item>
          <div>
            <div style={{ marginBottom: 15 }}>
              <Typography
                className={classes.pros}
                variant="title"
                style={{
                  fontWeight: 700,
                  color: '#4ab673',
                  textTransform: 'uppercase',
                }}
              >
                Pros:
              </Typography>
              <Typography
                style={{ paddingLeft: 15, listStyleType: 'circle' }}
                className={classes.ul}
                component="ul"
              >
                {pros.map((line) => <li key={line}>{line}</li>)}
              </Typography>
            </div>
            <div style={{ marginTop: 15 }}>
              <Typography
                className={classes.cons}
                variant="title"
                style={{
                  fontWeight: 700,
                  color: theme.palette.error.main,
                  textTransform: 'uppercase',
                }}
              >
                Cons:
              </Typography>
              <Typography
                style={{ paddingLeft: 15, listStyleType: 'circle' }}
                className={classes.ul}
                component="ul"
              >
                {cons.map((line) => <li key={line}>{line}</li>)}
              </Typography>
            </div>
          </div>
        </Grid>
      </Grid>
      <Divider
        style={{ margin: '20px 0', color: theme.palette.borders.cloudier }}
      />
      <div style={{ textAlign: 'center' }}>
        <a href={to}>
          <Button variant="raised" size="large" className={classes.button}>
            GO TO THE OFFICIAL WEBSITE
          </Button>
        </a>
      </div>
    </div>
  )
}

Summary.defaultProps = {
  pros: [],
  cons: [],
  statistics: {
    effectiveness: 0.0,
    valueForMoney: 0.0,
    testimonials: 0.0,
    company: 0.0,
  },
}

Summary.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  pros: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  cons: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  statistics: PropTypes.shape({
    effectiveness: PropTypes.number.isRequired,
    valueForMoney: PropTypes.number.isRequired,
    testimonials: PropTypes.number.isRequired,
    company: PropTypes.number.isRequired,
  }).isRequired,
  to: PropTypes.string.isRequired,
}

export default withStyles(styles, { withTheme: true })(Summary)



// WEBPACK FOOTER //
// ./src/components/Reviewpage/Summary.js